import React, { useEffect } from "react";
import AllRoutes from "./router/router";
import { useSelector } from "react-redux";
import { observer } from "mobx-react-lite";
import { useStore } from "../app/stores/store";
import { initializeUserAndLanguageSettings } from "../lib/userLanguageSettings";
import LoadingSpinner from "./common/LoadingSpinner";

const Feature = () => {
  const mobileSidebar = useSelector((state: any) => state.mobileSidebar);
  const { userStore } = useStore();

  useEffect(() => {
    initializeUserAndLanguageSettings(userStore);
  }, [userStore]);

  useEffect(() => {
    // Only try to get user if we have a token and user isn't already loaded
    if (userStore.token && !userStore.userLoaded) {
      userStore.getUser();
    } else if (!userStore.token && !userStore.userLoaded) {
      // If no token, mark user as loaded to unblock UI
      userStore.setUserLoaded(true); // <- use an action
    }
  }, [userStore]);

  if (!userStore.userLoaded || !userStore.appLoaded) {
    return <LoadingSpinner />;
  }

  return (
    <div className={`main-wrapper ${mobileSidebar ? "menu-opened true" : "false"}`}>
      <AllRoutes />
    </div>
  );
};

export default observer(Feature);
